import { Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import {ProcessInstanceQueryResult, ProcessVariables} from "../types/FlowableQueryResultsTypes";
import CsvDownloader from 'react-csv-downloader';
import { requestAll } from "../dashboard/SAReqDash";
import config from "../config";
import { isValidJSON } from "../utils/formatUtils";
import { MemberInfo } from "../types/UserInfoTypes";
import axios from "axios";

interface ProcessDefinition {
    key: string;
    name: string;
}

type SSOPOC = {
    requestNumber: string;
    email: string;
    isSSO: string;
}

const formatString = (value: string) => (
    value ? value.replace(/[\r\n]+/g," ") : ''
);

const savedReports = [
    {   name: "Choose Saved Report",
        variables: [''],
        key: '',
        type: ''
    },
    {
        name: "E-ICAM Government Security Team",
        variables: [
            "requestNumber",
            "legacyIsaIdentifier",
            "organizationunit",
            "organizationacronym",
            "officetelephonenumber",
            "mobiletelephonenumber",
            "requestorNotes",
            "requestorid",
            "requestor",
            "requestoralternateid",
            "requestoralternate",
            "customergovernmentsignatoryid",
            "customergovernmentsignatory",
            "customergovernmentsignatoryEmail",
            "isso",
            "issm",
            "documentationtype",
            "effectivestartdate",
            "atdexpirationdate",
            "daa",
            "iprouternetwork",
            "atotypedocumentdescription",
            "applicationname",
            "application",
            "applicationacronym",
            "applicationdescription",
            "emassidentifier",
            "environmenttype",
            "applicationdetails",
            "applicationsystemidentifier",
            "applicationsystemidentifiertype",
            "newSignOnRequestType",
            "apptechpoc",
            "apptechpocsipremail",
            "apptechpocalternatesipremail",
            "HostingLocation",
            "addnewhostingurl",
            "iaSupportTeamApprovalReason",
            "isaTeamApprovalReason",
            "returnreasonlabel"
        ],
        key: '',
        type: ''
    },
    {
        divider: true
    },
    {
        name: "All Customers",
        variables: ['displayName','firstName','lastName','email','fullName','id'],
        key: '',
        type: 'requestor'
    },
    {
        name: "EAMS-A Customers Only",
        variables: ['displayName','firstName','lastName','email','fullName','id'],
        key: ['SSO'],
        type: 'requestor'
    },
    {
        name: "AMID-LDAP Customers Only",
        variables: ['displayName','firstName','lastName','email','fullName','id'],
        key: ['LDAP'],
        type: 'requestor'
    },
    {
        name: "IGA Customers Only",
        variables: ['displayName','firstName','lastName','email','fullName','id'],
        key: ['IGA'],
        type: 'requestor'
    },
    {
        name: "PAM Customers Only",
        variables: ['displayName','firstName','lastName','email','fullName','id'],
        key: ['PAM'],
        type: 'requestor'
    },
    {
        divider: true
    },
    {
        name: "Government Approvers",
        variables: ['email', 'firstName', 'lastName','username'],
        key: [''],
        type: 'keycloak'
    },
    {
        divider: true
    },
    {
        name: "SSO POC (Detailed)",
        variables: ['requestNumber', 'isSSO', 'customergovernmentsignatoryEmail', 'customergovernmentsignatoryalternateEmail','apptechpoc','apptechpocalternate'],
        key: [''],
        type: 'ssopoc'
    },
    {
        name: "SSO POC (Combined)",
        variables: ['email'],
        key: [''],
        type: 'ssopoc'
    },
    {
        divider: true
    },
    {
        name: "All Technical POCs",
        variables: ['displayName','firstName','lastName','email','fullName','id'],
        key: [''],
        type: 'application'
    },
    {
        name: "EAMS-A Technical POCs",
        variables: ['displayName','firstName','lastName','email','fullName','id'],
        key: ['SSO'],
        type: 'application'
    },
    {
        name: "AMID-LDAP Technical POCs",
        variables: ['displayName','firstName','lastName','email','fullName','id'],
        key: ['LDAP'],
        type: 'application'
    },
    {
        name: "IGA Technical POCs",
        variables: ['displayName','firstName','lastName','email','fullName','id'],
        key: ['IGA'],
        type: 'application'
    },
    {
        name: "PAM Technical POCs",
        variables: ['displayName','firstName','lastName','email','fullName','id'],
        key: ['PAM'],
        type: 'application'
    },
    {
        divider: true
    },
    {
        name: "All Services (Applications)",
        variables: ['applicationacronym', 'applicationdescription', 'applicationsystemidentifier', 
            'applicationsystemidentifiersource', 'applicationsystemidentifiertype', 'emassidentifier', 
            'newSignOnRequestType'],
        key: '',
        type: 'application'
    },
    {
        name: "EAMS-A (Applications)",
        variables: ['applicationacronym', 'applicationdescription', 'applicationsystemidentifier', 
            'applicationsystemidentifiersource', 'applicationsystemidentifiertype', 'emassidentifier', 
            'newSignOnRequestType'],
        key: ['SSO'],
        type: 'application'
    },
    {
        name: "AMID-LDAP (Applications)",
        variables: ['applicationacronym', 'applicationdescription', 'applicationsystemidentifier', 
            'applicationsystemidentifiersource', 'applicationsystemidentifiertype', 'emassidentifier', 
            'newSignOnRequestType'],
        key: ['LDAP'],
        type: 'application'
    },
    {
        divider: true
    },
    {
        name: "AMID-LDAP (IP Addresses)",
        variables: ['applicationacronym', 'applicationdescription', 'applicationsystemidentifier', 
            'applicationsystemidentifiersource', 'applicationsystemidentifiertype', 'emassidentifier', 
            'newSignOnRequestType','addnewhostingurl'],
        key: ['LDAP'],
        type: 'application'
    }
]

export const Export = (): JSX.Element => {
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [processInstances, setProcessInstances] = useState<ProcessInstanceQueryResult[]>([]);
    const [status, setStatus] = React.useState<unknown|string>('all');
    const [processDefinitionKey, setProcessDefinitionKey] = React.useState<unknown|string>('siaTest');
    const [variables, setVariables] = useState<string[]>([]);
    const [savedReport, setSavedReport] = React.useState<unknown|string>('Choose Saved Report');

    useEffect(() => {
        setVariables([]);
    }, [processDefinitionKey]);

    const handleClose = () => {
        setOpen(false);
    };

    async function loadGovtApprovers(): Promise<MemberInfo[]> {
        const groupNames = ["E-ICAM", "IASupportTeam", "IGATeam", "ISLATeam", "LDAPTeam", "PAMTeam", "SSOTeam"];
        const all: MemberInfo[] = [];
        for (const names of groupNames){
            const groupNames = [names];
            const request = await requestAllGroups(`${config.flowableUiApiBaseUrl}idm-app/rest/groups`, {groupNames})
            if(request.length > 0){
                request.forEach(e => {
                        all.push(e)
                    });
            }
        }
        return all;
    }

    const loadProcessInstance = () => {
        setLoading(true);
        requestAll(`${config.flowableUiApiBaseUrl}app/rest/query/admin/process-instances`, {"state":"running","processVariableLike":{},"includeProcessVariables":true, "size": 50}).then((response) => {
            setLoading(false);
            setProcessInstances(response as ProcessInstanceQueryResult[]);
        })
    };

    const processDefinitions: ProcessDefinition[] = processInstances.reduce((accumulator: ProcessDefinition[], current: ProcessInstanceQueryResult) => {
        const processDefinition: ProcessDefinition | undefined = accumulator.find((item) => item.key === current.processDefinitionKey);
        if (! processDefinition) {
            return [...accumulator, {key: current.processDefinitionKey, name: current.processDefinitionName}];
        }
        return accumulator;
    }, [] as ProcessDefinition[]);

    const calculateReports = (variable: string | unknown) => {
        const matchingReport = savedReports.find((report) => report.name === variable);
        setVariables(matchingReport?.variables as string[]);
    }

    /* eslint-disable  @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types  */
    async function requestAllGroups(url: string,  options: any): Promise<MemberInfo[]> {
        //default amount of members returned, 50
        const size = 50;
        let page = 0;
        // there will only ever be one
      
        const initialResponse = await axios.post(url,
            {...{page, size}, ...options},
            { withCredentials: true });
        if (!initialResponse || !initialResponse.data) {
          return [];
        }
        const members = initialResponse.data[0] ? initialResponse.data[0]: {};
        /* eslint-disable  @typescript-eslint/no-explicit-any */
        let results: any[] = members.members;
        while (results.length < members.totalMembers) {
            page+= size;

          const response = await axios.post(url,
              {...{page, size}, ...options},
              { withCredentials: true });
      
          if (!response || !response.data) {
            break;
          }
          const membersMore = response.data[0] ? response.data[0] : {};
      
          results = [...results, ...membersMore.members];
      
        }
      
        return results;
    }


    const processExportData = async () => {
        const type = savedReports.find((report) => report.name === savedReport)?.type;
        let filteredProcessInstances;
        if (type==='requestor'){
            filteredProcessInstances = processInstances.filter((process: ProcessInstanceQueryResult) => {
                return (process.processDefinitionKey === 'siaTest' && process.businessKey) && ('00' === (process.businessKey.slice(-2)) && !process.businessKey.includes('DRAFT'))
            })
        }   
        else{
            filteredProcessInstances = processInstances;
        }
        
        // if filter applications . length then > add another filter in applications to check for types
        // eslint-disable-next-line
        const exportData: any[] = filteredProcessInstances
        .filter((process: ProcessInstanceQueryResult) => 
            // eslint-disable-next-line
            process?.processVariables?.applications ? (process.processVariables.applications.filter((e: any) => {
                const key = savedReports.find((report) => report.name === savedReport)?.key;
                return e.newSignOnRequestType.includes(key);
            }
            )).length >= 1 : false)
            // eslint-disable-next-line
        .filter((startProcessInstance: ProcessInstanceQueryResult) => (startProcessInstance.processDefinitionKey === processDefinitionKey)).reduce((accumulator: any[], current: ProcessInstanceQueryResult) => {
            let requestVariables;
            requestVariables = variables;
            if (type==='requestor'){
                requestVariables = ['requestor'];
            }
            if (type==='application'){
                requestVariables = ['applications','requestNumber'];
            }
            if (type==='ssopoc'){
                requestVariables = ['applications','requestNumber','isSSO','customergovernmentsignatoryEmail', 'customergovernmentsignatoryalternateEmail'];
            }
            // eslint-disable-next-line
            const processVariables: any = requestVariables.reduce((accumulator: any, variable) => {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                accumulator[variable] = current.processVariables[variable] ? (typeof current.processVariables[variable] === 'string' ? current.processVariables[variable] : JSON.stringify(current.processVariables[variable])) : '';
                return accumulator;
                // eslint-disable-next-line
            }, {} as  any);
            return [...accumulator, processVariables];
            // eslint-disable-next-line
        }, [] as any[]);
        let finalExportData = exportData;

        if(type === 'requestor'){
            finalExportData = exportData.map(e=>  { 
                return (isValidJSON(e?.requestor) ? JSON.parse(e?.requestor) : {})}).filter(e => e.id)
            // eslint-disable-next-line
            .reduce((accumulator: any[], current: ProcessVariables) => {
                // eslint-disable-next-line
                const processVariables: any = variables.filter((variableOption: string) => {
                    return variableOption !== 'requestor';
                    // eslint-disable-next-line
                }).reduce((accumulator: any, variable) => {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    accumulator[variable] = current[variable] ? (typeof current[variable] === 'string' ? current[variable] : JSON.stringify(current[variable])) : '';
                    
                    return accumulator;
                    // eslint-disable-next-line
                }, {} as  any);
                return [...accumulator, processVariables];
                // eslint-disable-next-line
            }, [] as any[]);
        }
        if(type === 'keycloak'){
            const groupMembers = await loadGovtApprovers();
            
            finalExportData = groupMembers.reduce((acc: any[], obj) => {
                if (!acc.some((o: MemberInfo) => o.id=== obj.id)) {
                    acc.push(obj);
                }
                return acc;
            }, []).reduce((accumulator: any[], current: MemberInfo) => {
                // eslint-disable-next-line
                const processVariables: any = variables.filter((variableOption: string) => {
                    return variableOption !== 'requestor';
                    // eslint-disable-next-line
                }).reduce((accumulator: any, variable) => {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    accumulator[variable] = current[variable] ? (typeof current[variable] === 'string' ? current[variable] : JSON.stringify(current[variable])) : '';
                    
                    return accumulator;
                    // eslint-disable-next-line
                }, {} as  any);
                return [...accumulator, processVariables];
                // eslint-disable-next-line
            }, [] as any[]);
        }
        if(type === 'ssopoc'){
            const isCombined = (savedReport as string).includes('SSO POC (Combined)');
            const ssoPoc: SSOPOC[] = [];
            // eslint-disable-next-line
            const applicationList = exportData.filter((e) => e.isSSO === 'true').reduce((accumulator: any, current) => {
                const requestNumber = current?.requestNumber ? current.requestNumber : '';
                const customergovernmentsignatoryEmail = current?.customergovernmentsignatoryEmail ? current.customergovernmentsignatoryEmail : '';
                const customergovernmentsignatoryalternateEmail = current?.customergovernmentsignatoryalternateEmail ? current.customergovernmentsignatoryalternateEmail : '';
                const isSSO = current?.isSSO ? current.isSSO : false;
                const currentApplications = isValidJSON(current?.applications) ? JSON.parse(current.applications) : [];
                // eslint-disable-next-line
                currentApplications.map((e: any) => {
                    const appTechPoc = e?.apptechpoc ? (isValidJSON(e?.apptechpoc) ? JSON.parse(e.apptechpoc as string).email : '') : '';
                    const appTechPocAlternate = e?.apptechpocalternate ? (isValidJSON(e?.apptechpocalternate) ? JSON.parse(e.apptechpocalternate as string).email : '') : '';
                    const totalEmails = [customergovernmentsignatoryEmail, customergovernmentsignatoryalternateEmail, appTechPoc, appTechPocAlternate].filter((e: any) => e)
                    e['requestNumber'] = requestNumber;
                    e['totalemails'] = totalEmails;
                    e['isSSO'] = isSSO;
                    e['apptechpoc'] = e?.apptechpoc ? (isValidJSON(e?.apptechpoc) ? JSON.parse(e.apptechpoc as string).email : '') : '';
                    e['apptechpocalternate'] = e?.apptechpocalternate ? (isValidJSON(e?.apptechpocalternate) ? JSON.parse(e.apptechpocalternate as string).email : '') : '';
                    e['requestNumber'] = requestNumber;
                    e['customergovernmentsignatoryEmail'] = customergovernmentsignatoryEmail;
                    e['customergovernmentsignatoryalternateEmail'] = customergovernmentsignatoryalternateEmail;
                    
                    totalEmails.forEach((e: string) => {
                        const o = {} as SSOPOC;
                        o.requestNumber = requestNumber;
                        o.isSSO = isSSO;
                        o.email = e
                        ssoPoc.push(o)
                    })
                    return e
                });
                if(isCombined) {
                    return [...accumulator, ...ssoPoc];
                } else {
                    return [...accumulator, ...currentApplications];
                }
            },[])
            // eslint-disable-next-line
            if(isCombined){
            finalExportData = ssoPoc.reduce((arr: SSOPOC[], e) => {
                if (!arr.find((item: SSOPOC) => item.email === e.email)) {
                    return [...arr, e];
                }
                    return arr;
            }, []).reduce((accumulator: any[], current: SSOPOC) => {
                // eslint-disable-next-line
                const processVariables: any = [ ...variables].reduce((accumulator: any, variable) => {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    accumulator[variable] = current[variable] ? (typeof current[variable] === 'string' ? formatString(current[variable]) : JSON.stringify(current[variable])) : '';
                    return accumulator;
                    // eslint-disable-next-line
                }, {} as  any);
                return [...accumulator, processVariables];
                // eslint-disable-next-line
            }, [] as any[]);
            } else {
                finalExportData = applicationList.reduce((accumulator: any[], current: ProcessVariables) => {
                    // eslint-disable-next-line
                    const processVariables: any = ['requestNumber', ...variables].reduce((accumulator: any, variable) => {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        accumulator[variable] = current[variable] ? (typeof current[variable] === 'string' ? formatString(current[variable]) : JSON.stringify(current[variable])) : '';
                        return accumulator;
                        // eslint-disable-next-line
                    }, {} as  any);
                    return [...accumulator, processVariables];
                    // eslint-disable-next-line
                }, [] as any[]);
            }
        }
        if(type === 'application'){
            if((savedReport as string).includes('Address')){
                // eslint-disable-next-line
                const applicationList = exportData.reduce((accumulator: any, current) => {
                    const requestNumber = current?.requestNumber ? current.requestNumber : '';
                    const currentApplications = isValidJSON(current?.applications) ? JSON.parse(current.applications) : [];
                    // eslint-disable-next-line
                    currentApplications.map((e: any) => {
                        e['requestNumber'] = requestNumber;
                        return e
                    })
                    return [...accumulator, ...currentApplications]
                },[])
                const key = savedReports.find((report) => report.name === savedReport)?.key;
                // eslint-disable-next-line
                finalExportData = applicationList.filter((e: any) => e.newSignOnRequestType.includes(key)).reduce((accumulator: any[], current: ProcessVariables) => {
                    // eslint-disable-next-line
                    const processVariables: any = ['requestNumber', ...variables].filter((variableOption: string) => {
                        return variableOption !== 'applications';
                        // eslint-disable-next-line
                    }).reduce((accumulator: any, variable) => {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        accumulator[variable] = current[variable] ? (typeof current[variable] === 'string' ? formatString(current[variable]) : JSON.stringify(current[variable])) : '';
                        return accumulator;
                        // eslint-disable-next-line
                    }, {} as  any);
                    return [...accumulator, processVariables];
                    // eslint-disable-next-line
                }, [] as any[]);
            }
            else if((savedReport as string).includes('Technical POCs')){
                // eslint-disable-next-line
                const applicationList = exportData.reduce((accumulator: any, current) => {
                    const requestNumber = current?.requestNumber ? current.requestNumber : '';
                    const currentApplications = isValidJSON(current?.applications) ? JSON.parse(current.applications) : [];
                    // eslint-disable-next-line
                    currentApplications.map((e: any) => {
                        e['requestNumber'] = requestNumber;
                        return e
                    })
                    
                    return [...accumulator, ...currentApplications]
                },[])
                const key = savedReports.find((report) => report.name === savedReport)?.key;
                // eslint-disable-next-line
                finalExportData = applicationList.filter((e: any) => e.newSignOnRequestType.includes(key)).reduce((accumulator: any[], current: ProcessVariables) => {
                    // eslint-disable-next-line
                    const processVariables: any = [ ...variables].reduce((accumulator: any, variable) => {
                        const appTechPoc = current?.apptechpoc ? (isValidJSON(current?.apptechpoc) ? JSON.parse(current.apptechpoc as string) : []) : [] ;
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        accumulator[variable] = appTechPoc[variable] ? (typeof appTechPoc[variable] === 'string' ? formatString(appTechPoc[variable]) : JSON.stringify(appTechPoc[variable])) : '';
                        return accumulator;
                        // eslint-disable-next-line
                    }, {} as  any);

                    const processVariablesAlternate: any = [ ...variables].reduce((accumulator: any, variable) => {
                        const appTechPocAlternate = current?.apptechpocalternate ? (isValidJSON(current?.apptechpocalternate) ? JSON.parse(current.apptechpocalternate as string) : []) : [] ;
                        if(appTechPocAlternate.length === 0){
                            return null;
                        }
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        else {
                            accumulator[variable] = appTechPocAlternate[variable] ? (typeof appTechPocAlternate[variable] === 'string' ? formatString(appTechPocAlternate[variable]) : JSON.stringify(appTechPocAlternate[variable])) : '';
                        return accumulator;
                        }
                        // eslint-disable-next-line
                    }, {} as  any);

                    if(processVariablesAlternate){
                        return [...accumulator, processVariables, processVariablesAlternate];
                    }
                    else {
                        return [...accumulator, processVariables]
                    }
                    // eslint-disable-next-line
                }, [] as any[]);
                // filtering down POCs
                finalExportData = finalExportData.reduce((arr: any[], e) => {
                        if (!arr.find((item: any) => item.email === e.email)) {
                            return [...arr, e];
                        }
                            return arr;
                    }, [])
            } 
            else {
                // eslint-disable-next-line
                const applicationList = exportData.reduce((accumulator: any, current) => {
                    const requestNumber = current?.requestNumber ? current.requestNumber : '';
                    const currentApplications = isValidJSON(current?.applications) ? JSON.parse(current.applications) : [];
                    // eslint-disable-next-line
                    currentApplications.map((e: any) => {
                        e['requestNumber'] = requestNumber;
                        return e
                    })
                    return [...accumulator, ...currentApplications]
                },[])
                const key = savedReports.find((report) => report.name === savedReport)?.key;
                // eslint-disable-next-line
                finalExportData = applicationList.filter((e: any) => e.newSignOnRequestType.includes(key)).reduce((accumulator: any[], current: ProcessVariables) => {
                    // eslint-disable-next-line
                    const processVariables: any = ['requestNumber', ...variables].filter((variableOption: string) => {
                        return variableOption !== 'applications';
                        // eslint-disable-next-line
                    }).reduce((accumulator: any, variable) => {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        accumulator[variable] = current[variable] ? (typeof current[variable] === 'string' ? formatString(current[variable]) : JSON.stringify(current[variable])) : '';
                        return accumulator;
                        // eslint-disable-next-line
                    }, {} as  any);
                    return [...accumulator, processVariables];
                    // eslint-disable-next-line
                }, [] as any[]);
            }
        }
        return Promise.resolve(finalExportData);
    };
    
    let variableOptions: string[] = processInstances.filter((startProcessInstance: ProcessInstanceQueryResult) => (startProcessInstance.processDefinitionKey === processDefinitionKey)).reduce((accumulator: string[], current: ProcessInstanceQueryResult) => {
        return [...accumulator, ...Object.keys(current.processVariables)];
    }, [] as string[]).reduce((accumulator: string[], current: string) => {
        
        if (! accumulator.includes(current)) {
            return [...accumulator, current];
        }
        return accumulator;
    }, [] as string[]).filter((variableOption: string) => {
        return variableOption !== 'applications';
    });

    if(savedReports.find((report) => report.name === savedReport)?.type === 'application') {
        variableOptions = processInstances.filter((startProcessInstance: ProcessInstanceQueryResult) => (startProcessInstance.processDefinitionKey === processDefinitionKey))
    .reduce((accumulator: string[], current: ProcessInstanceQueryResult) => {
        const applications = current?.processVariables?.applications ? current.processVariables.applications : [];
            if(applications){
                return [...accumulator, ...applications];
            }
            else {
                return [...accumulator, {}]
            }
    }, [] as string[]).reduce((accumulator: string[], current: string) => {
        if (!accumulator.includes(current)) {
            return [...accumulator, ...Object.keys(current)];
        }
        return accumulator;
    }, [] as string[]).reduce((accumulator: string[], current: string) => {
        if (! accumulator.includes(current)) {
            return [...accumulator, current];
        }
        return accumulator;
    }, [] as string[])}

    if(savedReports.find((report) => report.name === savedReport)?.type === 'requestor'){
        variableOptions = processInstances.filter((startProcessInstance: ProcessInstanceQueryResult) => (startProcessInstance.processDefinitionKey === processDefinitionKey))
    .reduce((accumulator: string[], current: ProcessInstanceQueryResult) => {
        return [...accumulator,  current?.processVariables?.requestor ? JSON.parse(current.processVariables.requestor) : {}];
    }, [] as string[]).reduce((accumulator: string[], current: string) => {
        
        if (!accumulator.includes(current)) {
            return [...accumulator, ...Object.keys(current)];
        }
        return accumulator;
    }, [] as string[]).reduce((accumulator: string[], current: string) => {
        if (! accumulator.includes(current)) {
            return [...accumulator, current];
        }
        return accumulator;
    }, [] as string[])} 

    if(savedReports.find((report) => report.name === savedReport)?.type === 'keycloak' ){
        variableOptions = ['email', 'firstName', 'lastName','username','id']
    }

    if(savedReports.find((report) => report.name === savedReport)?.name === 'SSO POC (Detailed)' ){
        variableOptions = ['requestNumber', 'isSSO', 'customergovernmentsignatoryEmail', 'customergovernmentsignatoryalternateEmail','apptechpoc','apptechpocalternate']
    }

    if(savedReports.find((report) => report.name === savedReport)?.name === 'SSO POC (Combined)' ){
        variableOptions = ['email']
    }

    if(savedReports.find((report) => report.name === savedReport)?.type === 'application'  && (savedReport as string).includes('Technical POCs')){
        variableOptions = ['displayName','firstName','lastName','email','fullName','id','groups', 'privilages','tenantId']
    }

    return (
        <>
            <Button color="primary" variant="contained" onClick={() => {setOpen(true); loadProcessInstance();}}>
                Export Data
            </Button>
        <Dialog open={open} onClose={handleClose} maxWidth={"xl"} fullWidth>
            <DialogTitle id="form-dialog-title">
                Export Options
            </DialogTitle>
            <DialogContent>
                <Grid container>
                    <Grid item xs={4}>
                        <FormControl style={{width: '90%'}}>
                            <InputLabel id="status">Status</InputLabel>
                            <Select
                                labelId="status"
                                id="status"
                                value={status}
                                onChange={(e) => {
                                  setStatus(e.target.value);
                                }}
                            >
                                <MenuItem value={'all'}>All</MenuItem>
                                <MenuItem value={'running'}>Running</MenuItem>
                                <MenuItem value={'completed'}>Completed</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                        <FormControl style={{width: '90%'}}>
                            <InputLabel id="process-definition">Process Definition</InputLabel>
                            <Select
                                labelId="process-definition"
                                id="process-definition"
                                value={processDefinitionKey}
                                onChange={(e) => {
                                    setProcessDefinitionKey(e.target.value);
                                }}
                            >
                                <MenuItem key={`choose-process-definition`} value={''}>Choose Process Definition</MenuItem>
                                {processDefinitions.map((processDefinition) => (
                                    <MenuItem key={processDefinition.key} value={processDefinition.key}>{processDefinition.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                        <FormControl style={{width: '90%'}}>
                            <InputLabel id="saved-reports">Saved Reports</InputLabel>
                            <Select  
                                labelId="saved-reports"
                                id="saved-reports"
                                defaultValue={''}
                                value={savedReport}
                                onChange={(e) => {
                                    setSavedReport(e.target.value);
                                    calculateReports(e.target.value);
                                }}
                            >
                                {savedReports.map((report) => (
                                    <MenuItem disabled={report.divider} key={report.name} value={report.name}>{report.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    
                </Grid>
                <h3>Variables</h3>
                <FormControlLabel
                            control={
                                <Checkbox
                                    checked={variables.length === variableOptions.length}
                                    onChange={() => {
                                        variables.length === variableOptions.length ? setVariables([]) : setVariables([...variableOptions])
                                    }}
                                    name={`select-all`}
                                />}
                            label={'Select All'}
                        />
                {loading ? <CircularProgress id={"migrateLoader"}/> : <Grid container>
                {variableOptions.sort().map((variableOption) => (
                    <Grid key={`variable-option-${variableOption}`} item xs={6}>
                        <Box component="div" textOverflow="ellipsis" style={{overflow: 'hidden'}}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={variables.includes(variableOption)}
                                    onChange={e => {
                                        e.target.checked ? setVariables([...variables, variableOption]) : setVariables(variables.filter((v) => (v !== variableOption)))
                                    }}
                                    name={`variable-${variableOption}`}
                                        />}
                            label={variableOption}
                        />
                        </Box>
                    </Grid>
                ))}
                </Grid>
                }
            </DialogContent>
            {loading ? <div/> : <DialogActions>
                <CsvDownloader filename={savedReport ? savedReport as string : "process-definitions"} datas={processExportData} separator="|" extension=".csv">
                    <Button color="primary" variant="contained">
                        Export Data
                    </Button>
                </CsvDownloader>
            </DialogActions>
            }
        </Dialog>
            <div style={{marginTop: 20}}>
                
            </div>
            </>
    );
};